<template>
  <div class="animated fadeIn">
    <loader :show="enviando"/>

    <b-card>
      <b-card-header 
        header-bg-variant="white"
        header-border-variant="white">
          <h4 id="traffic" class="card-title mb-0">{{title}}</h4>
      </b-card-header>
      <b-card-body>
          <b-row>
              <b-col sm="12" md="12" lg="4">
                <b-form-group id="exampleInputGroup1"
                            label="Fecha:">
                    <b-input-group>
                        <!-- <b-btn variant="outline-primary" @click="muestraCalendario()"><i class="fa fa-calendar"></i></b-btn> -->
                        <datepicker 
                            ref="calendario"
                            v-model="fechaPicker"
                            :language="lang"
                            :inline="true"
                            input-class="input-group form-input"
                        ></datepicker>
                        <b-input-group-append>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="12" lg="8">
                    <b-card no-body 
                            class="mb-2">

                        <crop-image v-if="cropImage"
                            :img="httpURL+'/'+noticia.imagen.path"
                            :width="650"
                            :height="300"
                            @cancelar="cropImage=false"
                            @guardar="cropImagen"
                        />
                        <div v-else class="show-image">
                            <b-card-img
                                :src="imagen"
                                img-alt="Image">
                            </b-card-img>

                            <div v-if="!subiendoImg" class="edit">
                                <b-button-group>
                                    <b-button v-if="noticia.imagen.path"
                                        size="sm" 
                                        variant="secondary"
                                        @click="cropImage = true">
                                        <i class="fa fa-arrows-alt fa-lg"></i>
                                    </b-button>
                                    <b-button 
                                        size="sm" 
                                        variant="secondary"
                                        @click="$refs.menuImg.click()">
                                        <i class="fa fa-pencil fa-lg"></i>
                                    </b-button>
                                </b-button-group>
                            </div>

                            <input 
                                type="file" 
                                @change="subeImagen" 
                                style="display: none;"
                                ref="menuImg" />
                            
                            <b-progress 
                                v-if="subiendoImg"
                                class="progreso-img" 
                                variant="primary" 
                                :value="progreso" 
                                :max="100" 
                                show-progress animated>
                            </b-progress>

                        </div>
                            
                        <b-card-body>
                            <div role="group">
                                <label for="inputLive">Título:</label>
                                <b-form-input id="inputLive"
                                            v-model="noticia.titulo"
                                            type="text"
                                            :state="tituloValido"
                                            aria-describedby="inputLiveHelp inputLiveFeedback"
                                            placeholder="Ingrese título"></b-form-input>
                                <b-form-invalid-feedback id="inputLiveFeedback">
                                <!-- This will only be shown if the preceeding input has an invalid state -->
                                Ingrese al menos 10 caracteres
                                </b-form-invalid-feedback>
                            </div>
                        </b-card-body>
                    </b-card>
              </b-col>
              <b-col md="12">
                  <vue-ckeditor 
                        v-model="noticia.descripcion" 
                        :config="editorConfig" 
                         />
              </b-col>
          </b-row>
      </b-card-body>
      
      <b-card-body>
          <b-button variant="secondary" @click="regresar()">
              Cancelar
          </b-button>
          <b-button variant="primary" class="pull-right" @click="modificarNoticia()" :disabled="!tituloValido">
              Guardar
          </b-button>
      </b-card-body>
      
    </b-card>
  </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker';
import swal from 'sweetalert'
import axios from 'axios'
import Loader from '../../Loader'
import CropImage from '../../CropImage'
import { mapGetters } from "vuex";

import {es} from 'vuejs-datepicker/dist/locale'
import date from 'date-and-time';
date.locale('es');

import VueCkeditor from 'vue-ckeditor2';

export default {
  name: 'ModificarNoticia',
  components: {
    Loader,
    Datepicker,
    VueCkeditor,
    CropImage
  },
  computed:{
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ]),
    fechaTexto(){
      return date.format(this.fechaPicker,'dddd D de MMMM de YYYY');
    },
    tituloValido(){
        return this.noticia.titulo.length < 10 ? false : true
    },
    imagen(){
        return this.noticia.imagen.path ? this.httpURL+'/'+this.noticia.imagen.path : '/img/brand/logo.png';
    }
  },
  data: function () {
    return {
      id: this.$route.params.id,
      title: this.$route.name,
      enviando: false,
      fechaPicker: new Date(),
      subiendoImg: false,
      progreso: 50,
      lang: es,
      cropImage: false,
      noticia:{
        titulo:'',
        imagen: {path:null,thumbs:null},
        },
      titulo: '',
      descripcion: null,
      editorConfig: {
        toolbar: [
          ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'],
          ['NumberedList','BulletedList','JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock','TextColor','BGColor'],
          ['Link','Table','SpecialChar','Styles','Format','Font','FontSize'],
          ['Cut','Copy','Paste','PasteText','PasteFromWord','Undo','Redo']
        ],
        height: 300
      }
    }
  },
  created(){
      if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero === 132) < 0)
        this.$router.go(-1);

    axios.get(this.httpURL+'/comsocial/noticias/'+this.id,{headers:{token:this.sessionToken}})
            .then(res => {
                //console.log(res.data);
                this.noticia = res.data.noticia;
                this.fechaPicker = new Date(this.noticia.fecha);
                this.enviando = false;
            })
            .catch(error => {
                this.enviando = false;
                if(error.response){
                    //console.log(error.response);
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                    this.$router.go(-1);
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                    this.$router.go(-1);
                }
            });
  },
  methods: {
    regresar(){
      this.$router.go(-1);
    },
    muestraCalendario(){
        this.$refs.calendario.showCalendar();
    },
    subeImagen(event){
        const file = event.target.files[0];
        const allowedTypes = ['image/jpg','image/jpeg','image/png','image/gif'];
        if( allowedTypes.includes(file.type)){
            const formData = new FormData();
            formData.append('image',file);
            this.subiendoImg = true;
            axios.put(this.httpURL+'/comsocial/noticias/imagen/'+this.id,
                formData,
                {headers: {token:this.sessionToken},
                onUploadProgress: e => this.progreso = Math.round(e.loaded * 100 / e.total)
                })
            .then(res => {
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                            text: res.data.mensaje });
                setTimeout(()=>{ 
                    this.noticia.imagen = res.data.imagen;
                    this.subiendoImg = false;
                }, 500);
            })
            .catch(error => {
                if(error.response){
                    //console.log(error.response);
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
                this.subiendoImg = false;
            });
        }else
            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                      text: 'Debe seleccionar una imagen.'+file.type });
    },
    cropImagen(file){
        this.cropImage = false;
        const formData = new FormData();
        formData.append('image',file);
        this.subiendoImg = true;
        axios.put(this.httpURL+'/comsocial/noticias/imagen/'+this.id,
            formData,
            {headers: {token:this.sessionToken},
            onUploadProgress: e => this.progreso = Math.round(e.loaded * 100 / e.total)
            })
        .then(res => {
            this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: res.data.mensaje });
            setTimeout(()=>{ 
                this.noticia.imagen = res.data.imagen;
                this.subiendoImg = false;
            }, 500);
        })
        .catch(error => {
            if(error.response){
                //console.log(error.response);
                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                    text: error.response.data.mensaje });
            }else if( error.request){
                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                    text: 'No se pudo establecer una conexión al servidor.' });
            }
            this.subiendoImg = false;
        });
    },
    modificarNoticia(){
        this.enviando = true;
        axios.put(this.httpURL+'/comsocial/noticias/'+this.id,
                {fecha: this.fechaPicker,
                titulo: this.noticia.titulo,
                descripcion: this.noticia.descripcion},
                {headers: {token:this.sessionToken}})
            .then(res => {
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                          text: res.data.mensaje });
                this.enviando = false;
                this.$router.go(-1);
            })
            .catch(error => {
                this.enviando = false;
                if(error.response){
                    //console.log(error.response);
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
            });
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

div.show-image {
    position: relative;
    float:left;
    margin:1px;
}
div.show-image:hover img{
    opacity:0.5;
}

div.show-image:hover .edit{
    display: block;
}

.edit {
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
	right: 5%;
	top: 10%;
	display: none;
}

div.show-image .progreso-img{
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
    width: 100%;
	top: 50%;
	display: block;
}

</style>
